/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TuitionType = {
    PerHour: 'PerHour',
    PerClass: 'PerClass',
    FlatAmount: 'FlatAmount'
} as const;
export type TuitionType = typeof TuitionType[keyof typeof TuitionType];


export function instanceOfTuitionType(value: any): boolean {
    for (const key in TuitionType) {
        if (Object.prototype.hasOwnProperty.call(TuitionType, key)) {
            if (TuitionType[key as keyof typeof TuitionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TuitionTypeFromJSON(json: any): TuitionType {
    return TuitionTypeFromJSONTyped(json, false);
}

export function TuitionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuitionType {
    return json as TuitionType;
}

export function TuitionTypeToJSON(value?: TuitionType | null): any {
    return value as any;
}

export function TuitionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TuitionType {
    return value as TuitionType;
}

